// extracted by mini-css-extract-plugin
export default {"card":"Card_card__J00sI","card_header":"Card_card_header__+W1W3","title":"Card_title__FC+QV"};